<div class="w-100" *ngIf="!!caseId">
  <h3>{{ 'Standard.Planned' | translate }}</h3>
  <div class="row">
    <div class="col-3 pr-0 mb-0">
      <label class="mb-0">{{ 'Standard.Date' | translate }}</label>
      <div class="input-group input-group-sm">
        <input type="text"
          class="form-control"
          placeholder="{{ 'Date.SelectDate' | translate }}"
          bsDatepicker
          #newTaskDatepicker="bsDatepicker"
          [bsConfig]="bsConfig"
          [(ngModel)]="taskDate"
          (bsValueChange)="newTask.date = $event?.toISOString()">
        <div class="input-group-append">
          <button type="button" class="btn btn-secondary" *ngIf="newTask.date" (click)="newTask.date = null; taskDate = null;">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <!-- toggle calendar button -->
        <div class="input-group-append">
          <button type="button" class="btn btn-secondary" (click)="newTaskDatepicker.toggle()">
            <i class="far fa-calendar-alt"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="col pr-0 mb-0">
      <label class="mb-0">{{ 'Standard.Time' | translate }}</label>
      <select class="form-control" [(ngModel)]="newTask.time">
        <option *ngFor="let x of time.dueTimes">{{ x }}</option>
      </select>
    </div>
    <div class="col pr-0 mb-0">
      <label class="mb-0">{{ ('Standard.Hours' | translate) | titlecase }}</label>
      <select class="form-control" [(ngModel)]="newTask.hours">
        <option *ngFor="let x of time.durationHours">{{ x }}</option>
      </select>
    </div>
    <div class="col pr-0 mb-0">
      <label class="mb-0">{{ ('Standard.Minutes' | translate) | titlecase }}</label>
      <select class="form-control" [(ngModel)]="newTask.minutes">
        <option *ngFor="let x of time.durationMinutes">{{ x }}</option>
      </select>
    </div>
    <div class="col-3 pr-0 mb-0">
      <label class="mb-0">{{ 'Standard.AssignedTo' | translate }}</label>
      <select [(ngModel)]="newTask.assignedTo" class="form-control" id="planFitter">
        <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
        <option *ngFor="let x of companyUsers" value="{{ x.userId }}">{{ x.name }}</option>
      </select>
    </div>
    <div class="col-auto text-right m-auto cursor-pointer">
      <span (click)="createTask()"><i class="fas fa-plus-square fa-2x mt-3 mb-0"></i></span>
    </div>
  </div>
  <!-- Case Tasks  -->
  <div class="row mt-2" *ngIf="showTaskList">
    <div class="col-12">
      <table class="table table-striped table-sm mb-0" aria-label="Task list">
        <thead>
          <tr>
            <th scope="col">{{ 'Standard.Fitter' | translate }}</th>
            <th scope="col">{{ 'Standard.StartTime' | translate }}</th>
            <th scope="col">{{ 'Standard.EndTime' | translate }}</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody *ngIf="!!caseTask">
          <tr>
            <td>{{ caseTask.fitter.value? caseTask.fitter.value: '' }}</td>
            <td>{{ (caseTask.startDateTime)? (caseTask.startDateTime + 'Z' | date:'dd-MM HH:mm'):'' }}</td>
            <td>{{ (caseTask.endDateTime)? (caseTask.endDateTime + 'Z' | date:'dd-MM HH:mm'):'' }}</td>
            <td class="text-right"><span (click)="deleteTask()"><i class="fas fa-trash"></i></span></td>
          </tr>
        </tbody>
        <tbody *ngIf="!caseTask">
          <tr>
            <td colspan="4" class="text-center">{{ 'Standard.CaseWithoutTime' | translate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>